import { useLocation } from "react-router-dom";
import { HealthBar } from "../health/HealthBar.js";
import { Icon } from "../ui/Icon.js";

const ROUTE_TITLES: Record<string, string> = {
  "/": "Dashboard",
  "/portfolio": "Portfolio",
  "/signals": "AI Signals",
  "/scanner": "Scanner",
  "/leaderboard": "Leaderboard",
  "/paper": "Paper Trading",
  "/live": "Live Trading",
  "/training": "AI Training Center",
  "/dca": "DCA Automation",
  "/alerts": "Price Alerts",
  "/health": "System Health",
  "/keys": "Exchange Keys",
  "/settings": "Settings",
};

export function Topbar() {
  const { pathname } = useLocation();
  const title = ROUTE_TITLES[pathname] ?? "SpotEdge";
  return (
    <div className="se-topbar">
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <span style={{ fontSize: 14, fontWeight: 600, letterSpacing: "-0.01em" }}>
          {title}
        </span>
      </div>
      <div style={{ marginLeft: "auto", display: "flex", alignItems: "center", gap: 10 }}>
        <span className="se-pill se-pill-ai" style={{ animation: "ai-pulse 2.5s infinite" }}>
          <Icon name="sparkle" size={10} />
          Self-learning model · v0.1
        </span>
        <HealthBar />
      </div>
    </div>
  );
}
